<template>
  <div class="simple-table">
    <table
      v-if="!isMobile"
      class="table-wrap"
    >
      <tr class="table-header table-row">
        <th
          v-for="(cell, index) in tableData.header"
          :key="index"
          v-dompurify-html="cell"
          class="table-cell header-cell"
        />
      </tr>

      <tr
        v-for="(row, index) in tableData.rows"
        :key="index"
        class="table-row"
      >
        <td
          v-for="(cell, cellIndex) in row"
          :key="cellIndex"
          class="table-cell"
        >
          <span
            v-if="showCheckIcon(cell)"
            class="icon check"
          />
          <span
            v-else-if="showRejectIcon(cell)"
            class="icon reject"
          />
          <span
            v-else
            v-dompurify-html="cell"
          />
        </td>
      </tr>
    </table>

    <div v-if="isMobile">
      <div
        v-for="(row, index) in tableData.rows"
        :key="index"
        class="table-row"
      >
        <div
          v-if="isEmptyHeaders"
          v-dompurify-html="row[0]"
          class="header-cell"
        />
        <div
          v-for="(cell, cellIndex) in row.slice(adjustIndex)"
          :key="cellIndex"
          class="table-cell"
        >
          <div
            v-dompurify-html="tableData.header[cellIndex + adjustIndex]"
            class="left-col"
          />
          <div class="right-col">
            <span v-if="showCheckIcon(cell) || showRejectIcon(cell.toString())">{{ $t(cell) }}</span>
            <span
              v-else
              v-dompurify-html="cell"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      tableData: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      ...mapGetters('device', [
        'isMobile'
      ]),

      isEmptyHeaders() {
        return this.tableData.header.every(header => header.trim() === '')
      },

      adjustIndex() {
        return this.isEmptyHeaders ? 1 : 0
      }
    },

    methods: {
      showCheckIcon (cell) {
        if (!cell) {
          return false
        }
        const formattedCell = cell.toString().toLowerCase()
        return formattedCell === 'table.yes' || formattedCell === 'table.included' || formattedCell === 'table.available'
      },

      showRejectIcon (cell) {
        if (!cell) {
          return false
        }
        const formattedCell = cell.toString().toLowerCase()
        return formattedCell === 'table.no' || formattedCell === 'table.notincluded' || formattedCell === 'table.notavailable'
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .simple-table {
    margin: 0 -23px;

    @include bp-mf-tablet {
      margin: 30px 0 0;
      white-space: pre-line;
    }

    img {
      margin: 0;
    }

    ::v-deep a {
      color: $blue-medium;

      &:hover {
        color: $blue-light;
      }
    }
  }

  .table-wrap {
    width: 100%;
  }

  .table-header {
    background: $gray-yellow;
  }

  .table-row {
    padding: 20px 23px;

    &:nth-child(2n) {
      background-color: $table-gray-background;
    }
  }

  td {
    padding: 16px 0;
  }

  th {
    padding: 13px 0;
    font-weight: 500;
  }

  th,
  td {

    &:first-child {
      text-align: left;
      padding-left: 18px;
    }

    &:last-child {
      padding-right: 18px;
    }
  }

  .table-cell {
    margin-top: 12px;
    @include clearfix();

    @include bp-mf-tablet {
      margin: 0;

      &:not(:first-child) {
        text-align: right;
        padding-left: 10px;
      }
    }
  }

  .header-cell {
    font-weight: 500;
    line-height: 16px;
  }

  .left-col {
    width: 65%;
    color: $grey;
    float: left;
  }

  .right-col {
    width: 35%;
    float: right;
    text-align: right;
  }

  .icon {
    @include line-icon-font();
    font-size: 16px;

    &.reject {

      &:before {
        content: $line-icon-block;
      }
    }

    &.check {

      &:before {
        content: $line-icon-check-circle;
        color: $blue-medium;
      }
    }
  }
</style>
